<template>
  <div>
    <div
      :class="setSemitransparent ? 'semitransparent' : ''"
      class="h-100 position-absolute"
      id="monitor-list"
      v-drag
    >
      <el-row class="table-header m-10">
        <el-col :span="12">
          <span>摄像头列表</span>
        </el-col>
        <el-col :span="12" class="tr">
          <!-- <el-button type="primary" size="mini" @click="getMonitorList">查看全部</el-button> -->
          <el-button type="primary" size="mini">查看全部</el-button>
        </el-col>
      </el-row>
      <!-- 路径列表 -->
      <div class="m-t-10 monitor-table">
        <el-table :data="dataList" v-loading="tableLoading" class="w-100" height="100%">
          <el-table-column type="index" label="序号" align="center" width="55"></el-table-column>
          <el-table-column prop="name" label="摄像头名称" align="center"></el-table-column>
          <el-table-column prop="distance" label="距离" align="center">
            <template #default="{row}">
              <span>{{ row.distance + 'm' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template #default="{row}">
              <el-tooltip placement="top" content="播放" :open-delay="1000">
                <el-button
                  type="success"
                  icon="el-icon-caret-right"
                  @click="runH5Player(row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="m-t-10 r">
        <el-pagination
          background
          :current-page.sync="pageNo"
          :page-size.sync="pageSize"
          :page-sizes="$pageSizeAll"
          layout="total, sizes,prev, pager, next"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </div>
    <!-- 监控弹框 -->
    <div id="camera_info" class="h-100 position-absolute semitransparent" v-if="showCamera" v-drag>
      <div class="camera_title fz-16 p-10 flex-row-between flex-align-center">
        <span>监控画面</span>
        <i class="cur_pointer iconfont icon-close" @click="closePlayer"></i>
      </div>
      <h5-player
        :showControl="true"
        class="play_wind"
        :cameraIndexCodeList="cameraIndexCodeList"
      ></h5-player>
    </div>
  </div>
</template>
<script>
import h5Player from '@/components/video/h5Player'
import MonitorManage from '@/services/monitorManage'
import PointManage from '@/services/pointManage'

export default {
  components: {
    h5Player,
  },
  props: {
    tagId: {
      type: String,
      default: '',
    },
    setSemitransparent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 15,
      pageTotal: 10,
      showCamera: false, // 控制播放器显示隐藏
      cameraIndexCodeList: [],
      monitorList: [
        { name: '空压机房1', cameraIndexCode: '294a1739d1d94fcb96c1bae2c07b55cd', distance: 1.0 },
        { name: '空压机房2', cameraIndexCode: '480576d500cc495cbced3cdb7dea3c62', distance: 1.4 },
        { name: '空压机房3', cameraIndexCode: '1268010dd48146d2a741094f4df3224c', distance: 1.6 },
        { name: '煤泥池1', cameraIndexCode: '82e6621a39a14668ac4ceecad57380d4', distance: 21 },
        { name: '煤泥池2', cameraIndexCode: '66dcf7b2855d4562b133adcc9d4d69f4', distance: 18 },
        { name: '煤泥池3', cameraIndexCode: '01058f0b601645939a389fdc879b1331', distance: 18 },
        { name: '一号堆放区', cameraIndexCode: '9250cf87b88a41be80a80a07c10fb587', distance: 10 },
        { name: '二号堆放区', cameraIndexCode: '1b910294c2f04c9589957bccc47cfeca', distance: 14 },
        { name: '三号堆放区', cameraIndexCode: '37b45ec5de6b49edb01dba356bd5927c', distance: 12 },
        { name: '四号堆放区', cameraIndexCode: 'fc2e0187ded54b0782d50a17cd94d63d', distance: 8 },
      ], // 摄像头列表
      pointList: [], // 点位列表
      relationList: [],
      pointInfo: [],
      markers: [],
      tableLoading: false,
    }
  },
  created() {
    // this.getMonitorList()
    // this.getPointList()
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    // 前端分页处理
    dataList() {
      return this.monitorList.slice((this.pageNo - 1) * this.pageSize, this.pageNo * this.pageSize)
    },
  },
  watch: {},
  async beforeDestroy() {
    // 检查是否有已知的标记
    const markerList = await PlayerUtils.call(window.player.Native.GisMarker.getMarkerList)
    _.forEach(markerList, (el) => {
      window.player.Native.GisMarker.destroy(el.id)
    })
  },
  methods: {
    // 获取模型code的三维向量
    async getModelPos(code) {
      const modelInfo = await PlayerUtils.call(window.player.Native.ModelTree.calcItemAabb, code)
      if (!_.isEmpty(modelInfo)) {
        const modelCodePos = [
          1 * modelInfo.aabb.min[0] + (modelInfo.aabb.max[0] - modelInfo.aabb.min[0]) / 2,
          1 * modelInfo.aabb.min[1] + (modelInfo.aabb.max[1] - modelInfo.aabb.min[1]) / 2,
          1 * modelInfo.aabb.min[2] + (modelInfo.aabb.max[2] - modelInfo.aabb.min[2]) / 2,
        ]
        return modelCodePos
      }
      return [0, 0, 0]
    },
    async getPointList() {
      const params = {
        pageno: 1,
        pagesize: 99999,
        pointtypeid: '',
        relation_model_document_id: this.$route.query.documentId || '',
      }
      const res = await PointManage.getPointList(params)
      if (res && res.data && res.code === 0) {
        _.forEach(res.data, async (item) => {
          const pos = item.location.split(',')
          // 加载锚点
          const imgId = await PlayerUtils.call(
            window.player.Native.GisMarker.loadImage,
            `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/${item.style}`
          )
          this.drawPoint(pos, imgId, item.code)
        })
        window.player.Native.GisMarker.EventGisMarkerLClick.connect(this.clickMarker)
      }
    },
    // 点击模型时
    clickModel(code) {
      console.log(code)
      if (code) {
        this.$nextTick(async () => {
          this.monitorList = []
          this.pageTotal = 0
          this.tableLoading = true
          const list = await this.getRelationList(1, code)
          this.monitorList = _.map(list, (item) => {
            return {
              id: item.videoMonitorId,
              name: item.videoMonitorName,
              code: item.videoMonitorCode,
              distance: 0,
            }
          })
          _.forEach(this.relationList, async (item) => {
            const start = await this.getModelPos(code)
            const end = await this.getModelPos(item.tagCode)
            if (start && end) {
              const distance = this.getPointDistance(start, end)
              this.monitorList.push({
                id: item.id,
                name: item.name,
                code: item.code,
                distance: _.round(distance, 3),
              })
              this.monitorList = _.sortBy(this.sortList(this.monitorList), (el) => {
                return el.distance
              })
            }
            this.pageTotal = this.monitorList.length
          })
          this.tableLoading = false
        })
      }
    },
    // 获取关联列表
    async getRelationList(type, code) {
      const dataParams = {
        type,
        siteid: this.currentProject.id,
        pageno: 1,
        pagesize: 99999,
        relationcode: code,
      }
      const res = await MonitorManage.getRelationList(dataParams)
      if (res && res.code === 0 && res.data) {
        return res.data
      }
      return []
    },
    // 点击点位
    async clickMarker(e) {
      window.player.Native.ModelTree.restoreAllItemColor()
      this.monitorList = []
      this.pageTotal = 0
      this.tableLoading = true
      const point = _.find(this.pointInfo, ['markerId', e.markerId])
      if (point) {
        const list = await this.getRelationList(3, point.code)
        this.monitorList = _.map(list, (item) => {
          return {
            id: item.videoMonitorId,
            name: item.videoMonitorName,
            code: item.videoMonitorCode,
            distance: 0,
          }
        })
        _.forEach(this.relationList, async (item) => {
          const start = e.markerInfo.pos
          const end = await this.getModelPos(item.tagCode)
          if (start && end) {
            const distance = this.getPointDistance(start, end)
            this.monitorList.push({
              id: item.id,
              name: item.name,
              code: item.code,
              distance: _.round(distance, 3),
            })
            this.monitorList = _.sortBy(this.sortList(this.monitorList), (el) => {
              return el.distance
            })
          }
          this.pageTotal = this.monitorList.length
        })
        this.markers = []
        this.tableLoading = false
      }
    },
    sortList(list) {
      const arr = _.uniqBy(list, 'id')
      const newList = _.filter(arr, (item) => {
        return item.distance <= 100
      })
      return newList
    },
    // 绘制点位
    async drawPoint(pos, imgId, code) {
      const option = {
        pos, // 定位点，世界坐标，三维向量
        visible: true, // 显示隐藏状态
        size: [20, 20], // 整体尺寸，二维向量，-1表示不限制，自动大小
        nodeOffset: [-10, -10], // 相对定位点的偏移量，二维向量
        imgId, // 图片
        imgSize: [20, 20], // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
        imgOffset: [0, 0], // 图片相对标记的偏移量
        text: '', // 文本
        fontSize: 14.0, // 字体大小
        breakWidth: 250, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
        textOffset: [0, 0], // 文字相对标记的偏移量
        textColor: 0xffffffff, // 文本颜色
        title: '', // 标题
        titleFontSize: 18.0, // 标题文字大小
        titleColor: 0xffffffff, // 标题颜色
        userData: null, // 用户数据，仅帮外部系统保存数据
      }
      const markerId = await PlayerUtils.call(window.player.Native.GisMarker.create, option)
      this.pointInfo.push({ markerId, code })
    },
    // 获取监控设备列表
    async getMonitorList() {
      const dataParams = {
        siteId: this.currentProject.id,
        pageno: 1,
        pagesize: 99999,
      }
      this.tableLoading = true
      this.monitorList = []
      const res = await MonitorManage.getMonitorList(dataParams)
      this.tableLoading = false
      if (res && res.code === 0 && res.data) {
        this.relationList = res.data
        this.monitorList = _.map(res.data, (item) => {
          // 接收列表item
          return {
            id: item.id,
            name: item.name,
            code: item.code,
            distance: 0,
          }
        })
        if (res.page) {
          this.pageTotal = res.page.recordCount
        }
      }
      console.log(res)
    },
    // 打开播放组件
    runH5Player(row) {
      this.showCamera = true
      this.cameraIndexCodeList.push(row.cameraIndexCode)
    },
    // 关闭播放组件
    closePlayer() {
      this.showCamera = false
      this.cameraIndexCodeList = []
    },
    /**
     * 求出点与点之间
     *  */
    getPointDistance(start, end) {
      const distance = Math.sqrt(
        Math.pow(start[0] - end[0], 2) +
          Math.pow(start[1] - end[1], 2) +
          Math.pow(start[2] - end[2], 2)
      )
      return distance
    },
  },
}
</script>
<style lang="scss" scoped>

@import '../css/semitransparent.scss';
#monitor-list {
  height: 500px;
  width: 400px;
  left: 8px;
  bottom: 2px;
  background-color: rgba(255, 255, 255, 0.76);
  border-radius: 4px;
  z-index: 99;
  .monitor-table {
    height: calc(100% - 100px);
  }
}
#camera_info {
  height: 410px;
  width: 720px;
  left: calc(50% - 240px);
  top: 170px;
  background-color: rgba(255, 255, 255, 0.76);
  border-radius: 4px;
  z-index: 99;
  .camera_title {
    box-sizing: content-box;
  }
  .play_wind {
    height: 360px;
  }
}

</style>
